import { render, staticRenderFns } from "./PageNotFoundCard.vue?vue&type=template&id=62d2e094&scoped=true&"
import script from "./PageNotFoundCard.vue?vue&type=script&lang=js&"
export * from "./PageNotFoundCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d2e094",
  null
  
)

export default component.exports